import React, { useEffect, useState, useRef, useMemo } from 'react';
import Filter from '@/pages/intelligence/pages/TopCharts/components/CommonFilter';
import TrendsCard from './components/TrendsCard';
import ChannelsCard from './components/ChannelsCard';
import CountriesCard from './components/CountriesCard';
// import './index.scss';
import {
  statsRetentionMonthlyTrends,
  statsRetentionMonthlyEditionShare,
  statsRetentionMonthlyMarketShare,
} from '@/pages/intelligence/services/topcharts';
import useEarliestTime from '../../utilsTmp/useEarliestTime';
import { getTopList, getMaketsType, getFixedTableData } from '../../utilsTmp/countryUtils';
import './index.scss';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import {
  retentionAvgOptions,
  retentionOptions,
} from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/RetentionCloums';
import { sortTableByMetric } from '@/pages/intelligence/utils/tableUtils';
import { DBI_TOPCHARTS } from '@/pages/intelligence/models/topcharts';
import { DownloadTitleTips } from '../_config';
import ExportTable from '../../../../../../../components/ExportTable';
import { getDefaultTime } from '@/pages/intelligence/utils/topchartsUtils';
import {
  filteredObject,
  getDbiFilterParams,
  getFilterValueParams,
} from '@intelligence/utils/filterUtils';
import { useSelector, history } from 'umi';
import {
  updateShortLinkFilterId,
  updateTimeFilterValue,
  URL_2_ORDER,
  URL_2_RATIO_TYPE,
  URL_2_SORT_NAME,
  URL_FILTER_KEY,
  URL_APP_IDS,
  URL_SHORT_LINK_NAME,
  URL_COUNTRIES_TYPE,
  URL_SORT_NAME,
} from '@intelligence/utils/urlPathCfg';
import { useMobileDetailShortLink } from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/_hook';
import { mobileStats } from '@intelligence/v3/constants/downloadLogPoint';
import {
  renderOpinionEventToolbar,
  useMobileStatsOpinionEvents,
} from '../useMobileStatsOpinionEvents';

export default function RetentionMonthly(props: any) {
  const {
    isBasicLoading,
    loading,
    setLoading,
    isCalibrated,
    tabType,
    pageId /** activeusers  revenue downloads*/,
    basicInfo,
    appIdListAll,
    unPublishedAppIdList,
    gameId,
    appIds,
    isTwoMonths,
    filterCfg,
    filterLoading,
    isCoutriesPage,
    shortLinkValidQuery,
    shortLinkFilterValue,
    urlCustomParams,
    entityType,
    regionsCountries,
    combineGameIdList,
    dataSource = 'appannie',
    monthlyRetentionIsolationKey = 0,
  } = props;

  const isoKey = monthlyRetentionIsolationKey ?? 0;

  /** 稳定短链筛选引用，避免父组件反复 new 同一内容对象触发重复整页拉数 */
  const shortLinkFilterStableKey = useMemo(() => {
    if (shortLinkFilterValue == null || shortLinkFilterValue === '') {
      return '';
    }
    if (typeof shortLinkFilterValue !== 'object') {
      return String(shortLinkFilterValue);
    }
    try {
      return JSON.stringify(shortLinkFilterValue);
    } catch {
      return String(shortLinkFilterValue);
    }
  }, [shortLinkFilterValue]);

  const retentionAbortRef = useRef<AbortController | null>(null);
  const currentDataSource = dataSource === 'sensortower' ? 'sensortower' : 'appannie';
  const topchartsState = useSelector((state: any) => state?.[DBI_TOPCHARTS] || {});
  const countryTypeRef = useRef('market');
  /** ST↔data.ai 月度切换首帧：不应用短链配置、不写回排序类 URL，直至主 effect 完成 */
  const isolationAppliedRef = useRef(false);
  const DEFAULT_FORM_VALUE = filterCfg?.defaultValue || [];
  const { hasUrlShortLink } = filterCfg || {};
  const [editionMetricSegVal, setEditionMetricSegVal] = useState(
    isoKey > 0 ? 'D2' : shortLinkValidQuery?.[URL_2_SORT_NAME] || 'D2',
  );
  const [countriesMetricSegVal, setCountriesMetricSegVal] = useState(
    isoKey > 0 ? 'D2' : shortLinkValidQuery?.[URL_SORT_NAME] || 'D2',
  );
  const [fetchParams, setFetchParams] = useState({
    app_ids: appIds,
    metrics: ['D2', 'D3', 'D7'],
    region_type: 'region',
    regions: ['global'],
    data_source: currentDataSource,
    start_date: '',
    end_date: '',
    order_field: 'D2',
    order: 'desc',
    date_type: 'month',
    platforms: ['googleplay', 'appstore'],
  });

  const [trendLineList, setTrendLineList] = useState<any>([]);
  const [trendTableList, setTrendTableList] = useState<any>([]);
  const [editionLineList, setEditionLineList] = useState<any>([]);
  const [editionTotalList, setEditionTotalList] = useState<any>([]);
  const [editionTableList, setEditionTableList] = useState<any>([]);
  const [marketLineList, setMarketLineList] = useState<any>([]);
  const [marketTotalList, setMarketTotalList] = useState<any>([]);
  const [marketTableList, setMarketTableList] = useState<any>([]);
  const [trendLoading, setTrendLoading] = useState(loading);
  const [editionLoading, setEditionLoading] = useState(loading);
  const [marketLoading, setMarketLoading] = useState(loading);
  const [topList, setTopList] = useState(
    /* <TopListProp>*/ {
      total: {},
      global: {},
      globalWoChina: {},
      list: [],
    },
  );
  const { isOperateDetail, detailFilterExtend, setDetailFilterExtend } = useFilterExtend({});
  const [filterValue, setFilterVale] = useState(() =>
    isoKey > 0 ? DEFAULT_FORM_VALUE : isOperateDetail ? detailFilterExtend : DEFAULT_FORM_VALUE,
  );
  const [trendError, setTrendError] = useState(false);
  const [editionError, setEditionError] = useState(false);
  const [marketError, setMarketError] = useState(false);
  const [marketFixedTableData, setMarketFixedTableData] = useState([]);
  const [editonFixedTableData, setEditionFixedTableData] = useState<any[]>([]);

  const [marketChartType, setMarketChartType] = useState<string>('line');
  // 获取计算总数的类型字段
  const [marketType, setMarketType] = useState(
    getMaketsType(fetchParams.regions, fetchParams.regions),
  );

  const {
    setEarliestDay,
    earliestPeriod,
    setEarliestPeriod,
    formattedEarliestDay,
    earliestLoading,
    getEarliestDayAndEarliesPeriod,
    updateEarliestDateData,
    baseReleaseTimeValue,
    baseReleaseTimeData,
  } = useEarliestTime({
    entityType: 'mobile',
    basicInfo,
    appIds,
    dateType: 'month',
    topchartsState,
  });

  const { enableOpinionEvents, controlledEventAnnotation, opinionEventToolbar } =
    useMobileStatsOpinionEvents({
      pageId,
      tabType,
      isCoutriesPage,
      gameId,
      combineGameIdList,
      entityType,
      fetchParams,
      trendLineList,
    });

  const {
    onTableSortChageTrend,
    onTableSortChageEdition,
    onTableSortChageCountrie,
    updateMobileDetailShortLink,
    updatePageCfgFromShortLink,
    trendPageSortAttr,
    editionPageSortAttr,
    countriesPageSortAttr,
    setEditionPageSortAttr,
    setCountriesPageSortAttr,
  } = useMobileDetailShortLink({
    coutriesType: countryTypeRef.current,
    trendSortMetric: 'date',
    editionSortMetric: editionMetricSegVal,
    countrieSortMetric: countriesMetricSegVal,
    shortLinkValidQuery,
    isCoutriesPage,
    marketChartType,
    // editionChartType,
    setMarketChartType,
    // setEditionChartType,
    // trendSegement: trendMetricSegVal,
    // setTrendSegement: setTrendMetricSegVal,
    editionSegement: editionMetricSegVal,
    setEditionSegement: setEditionMetricSegVal,
    coutriesSegement: countriesMetricSegVal,
    setCoutriesSegement: setCountriesMetricSegVal,
  });

  useEffect(() => {
    if (isoKey > 0 && !isolationAppliedRef.current) {
      return;
    }
    updatePageCfgFromShortLink();
    if (isCoutriesPage) {
      if (shortLinkValidQuery?.[URL_COUNTRIES_TYPE] !== undefined) {
        countryTypeRef.current = shortLinkValidQuery?.[URL_COUNTRIES_TYPE];
      }
    }
  }, [shortLinkValidQuery, isoKey]);

  useEffect(() => {
    if (!filterLoading && hasUrlShortLink) {
      if (isoKey > 0 && !isolationAppliedRef.current) {
        return;
      }
      updateMobileDetailShortLink();
    }
  }, [
    filterLoading,
    isCoutriesPage,
    marketChartType,
    countryTypeRef.current,
    editionMetricSegVal,
    countriesMetricSegVal,
    isoKey,
  ]);

  useEffect(() => {
    // 是否请求完basic接口
    if (isBasicLoading || filterLoading) {
      retentionAbortRef.current?.abort();
      // 选择单appid时要重新loading
      setLoading(true);
    } else {
      retentionAbortRef.current?.abort();
      retentionAbortRef.current = new AbortController();
      const signal = retentionAbortRef.current.signal;

      let newFetchParams = { ...fetchParams, data_source: currentDataSource };

      const bypassInherit = isoKey > 0 && !isolationAppliedRef.current;

      const hasUrlShortLinkVal = bypassInherit
        ? false
        : history.location.query?.[URL_SHORT_LINK_NAME];

      const filterKeyList =
        filterCfg?.filterKeyList ?? Object.keys(DEFAULT_FORM_VALUE ?? {});

      const resolvedFromPageDefaults = (): {
        updateFilterData: Record<string, any>;
        params: Record<string, any>;
      } => {
        const validDefault = filteredObject(filterCfg?.defaultValue ?? {}, filterKeyList);
        return getFilterValueParams(
          validDefault,
          filterCfg?.specialParams ?? {},
          filterKeyList,
        );
      };

      let newFilterValues: Record<string, any>;
      let filterParams: Record<string, any>;

      if (bypassInherit) {
        /** getDbiFilterParams 在无 URL / 无继承命中时不回填默认值，会得到 {}，
         * 进而 handleDetailRetentionFilterParamsToApi 返回 {}，首发触发后端校验失败。
         * 切换数据源时用页面默认值构建完整筛选项→接口参数，只做一轮加载 */
        const resolved = resolvedFromPageDefaults();
        newFilterValues = resolved.updateFilterData;
        filterParams = resolved.params;
      } else {
        const resolved = getDbiFilterParams({
          urlCustomParams,
          urlShortLinkFilter: shortLinkFilterValue,
          filterSaveData: null,
          filterExtend: detailFilterExtend,
          specialParams: filterCfg?.specialParams,
          isOperate: isOperateDetail,
          filterName: '',
          filterKeyList,
        });
        newFilterValues = resolved.filterValue;
        filterParams = resolved.filterParams;
      }

      let apiFromFilters = filterCfg?.handleFilterToApiParams(filterParams);
      /** 直连月度留存 / URL 无筛选命中时 filterParams 为空；或国家交集尚未产出 regions/metrics，首发仍会校验失败 */
      const apiIncomplete =
        !filterParams ||
        Object.keys(filterParams).length === 0 ||
        !Array.isArray(apiFromFilters?.metrics) ||
        apiFromFilters.metrics.length === 0 ||
        !Array.isArray(apiFromFilters?.regions) ||
        apiFromFilters.regions.length === 0;

      if (apiIncomplete) {
        const resolved = resolvedFromPageDefaults();
        newFilterValues = resolved.updateFilterData;
        filterParams = resolved.params;
        apiFromFilters = filterCfg?.handleFilterToApiParams(filterParams);
      }

      // 如果有短链接，设置为继承模式
      if ((isOperateDetail || hasUrlShortLinkVal) && !bypassInherit) {
        // 如果目前是继承模式，就设置继承值为过滤后的筛选器值
        setDetailFilterExtend(newFilterValues);
      }
      setFilterVale(newFilterValues);
      newFetchParams = {
        ...newFetchParams,
        ...apiFromFilters,
      };
      getPageData(newFetchParams, newFilterValues, {
        bypassShortLinkSort: bypassInherit,
        signal,
      });
      /** 首次和切换国家筛选器时getEairly为true，调用最早时间函数 */
      updateEarliestDateData({
        dataSources: [newFetchParams.data_source],
        metrics: newFetchParams.metrics,
        regionType: newFetchParams.region_type,
        regions: newFetchParams.regions,
        dateType: newFetchParams.date_type,
        platforms: newFetchParams?.platforms,
        signal,
      });

      if (bypassInherit) {
        isolationAppliedRef.current = true;
      }
    }
    return () => {
      retentionAbortRef.current?.abort();
    };
  }, [
    isBasicLoading,
    filterLoading,
    shortLinkFilterStableKey,
    currentDataSource,
    isoKey,
  ]);

  const getStatsData = async (
    params = fetchParams,
    updateFilterValues = filterValue,
    fetchOpts?: { bypassShortLinkSort?: boolean; signal?: AbortSignal },
  ) => {
    if (fetchOpts?.signal?.aborted) {
      return;
    }
    const newFetchParams = { ...fetchParams, ...params, data_source: currentDataSource };
    newFetchParams.app_ids = appIds;
    setFetchParams(newFetchParams);
    // setReqParamsDownLoad({ ...newFetchParams });
    try {
      /** 接口速率优化：
       * 第一次时间为空时先请求trend获取时间后再请求channel；
       * 如果时间不为空，则可以同时请求2个接口
       */

      let trendFetchParams = { ...newFetchParams };
      const datesWereEmpty =
        trendFetchParams.start_date === '' || trendFetchParams.end_date === '';

      if (trendFetchParams.start_date === '' || trendFetchParams.end_date === '') {
        const { start_date, end_date } = await getTrends(trendFetchParams, fetchOpts);
        if (fetchOpts?.signal?.aborted) {
          return;
        }
        if (start_date && end_date) {
          newFetchParams.start_date = start_date;
          newFetchParams.end_date = end_date;
          getEdition(newFetchParams, fetchOpts);
        } else {
          const [defautStart, defautEnd] = getDefaultTime(newFetchParams.date_type, isTwoMonths);
          newFetchParams.start_date = defautStart;
          newFetchParams.end_date = defautEnd;
          setEditionLoading(false);
        }
        setFetchParams(newFetchParams);

        const newFilterValue = updateTimeFilterValue({
          filterValue: updateFilterValues,
          timeFilterValues: {
            type: newFetchParams.date_type,
            value: [newFetchParams.start_date, newFetchParams.end_date],
          },
        });
        setFilterVale(newFilterValue);
        if (hasUrlShortLink) {
          updateShortLinkFilterId({ [URL_FILTER_KEY]: newFilterValue, [URL_APP_IDS]: appIds });
        }
      } else {
        if (datesWereEmpty) {
          if (fetchOpts?.signal?.aborted) {
            return;
          }
          setFetchParams(newFetchParams);
          const newFilterValue = updateTimeFilterValue({
            filterValue: updateFilterValues,
            timeFilterValues: {
              type: newFetchParams.date_type,
              value: [newFetchParams.start_date, newFetchParams.end_date],
            },
          });
          setFilterVale(newFilterValue);
          if (hasUrlShortLink) {
            updateShortLinkFilterId({ [URL_FILTER_KEY]: newFilterValue, [URL_APP_IDS]: appIds });
          }
        } else if (hasUrlShortLink) {
          updateShortLinkFilterId({ [URL_FILTER_KEY]: updateFilterValues, [URL_APP_IDS]: appIds });
        }
        if (fetchOpts?.signal?.aborted) {
          return;
        }
        getTrends(newFetchParams, fetchOpts);
        getEdition(newFetchParams, fetchOpts);
      }
    } catch (err) {
      if (fetchOpts?.signal?.aborted) {
        return;
      }
      console.error(err);
      setTrendLoading(false);
      setEditionLoading(false);
    }
  };

  const getTrends = async (
    params: any,
    opts?: { bypassShortLinkSort?: boolean; signal?: AbortSignal },
  ) => {
    if (opts?.signal?.aborted) {
      return {
        start_date: '',
        end_date: '',
      };
    }
    setTrendLoading(true);
    setLoading(true);
    let newFetchParams = { ...fetchParams, ...params, data_source: currentDataSource };
    const orderField = newFetchParams?.metrics?.includes(newFetchParams?.order_field)
      ? newFetchParams?.order_field
      : newFetchParams?.metrics?.[0];
    newFetchParams = {
      ...newFetchParams,
      order_field: opts?.bypassShortLinkSort
        ? orderField
        : shortLinkValidQuery?.[URL_SORT_NAME] || orderField,
    };
    // eslint-disable-next-line no-prototype-builtins
    if (newFetchParams.hasOwnProperty('app_ids') && !newFetchParams.app_ids?.length) {
      setTrendLineList([]);
      setTrendTableList([]);
      setTrendLoading(false);
      setLoading(false);
      setTrendError(true);
      return {
        start_date: '',
        end_date: '',
      };
    }
    setFetchParams(newFetchParams);
    // setReqParamsDownLoad({ ...newFetchParams });
    try {
      const trendRes = await statsRetentionMonthlyTrends(newFetchParams, {
        signal: opts?.signal,
      });
      if (opts?.signal?.aborted) {
        setTrendLoading(false);
        setLoading(false);
        return {
          start_date: '',
          end_date: '',
        };
      }
      const startDate = trendRes?.req?.start_date;
      const endDate = trendRes?.req?.end_date;
      const reqApi = {
        ...newFetchParams,
        start_date: startDate,
        end_date: endDate,
      };
      // setReqParamsDownLoad({ ...reqApi });
      setFetchParams({ ...reqApi });
      setTrendLineList(trendRes?.data?.trends || []);
      setTrendTableList(trendRes?.data?.list || []);
      // 给时间筛选器赋值
      // setDateTimeDatas('month', startDate, endDate);
      setTrendLoading(false);
      setLoading(false);
      setTrendError(false);
      return {
        start_date: startDate,
        end_date: endDate,
      };
    } catch (err) {
      if (opts?.signal?.aborted) {
        return {
          start_date: '',
          end_date: '',
        };
      }
      setTrendLineList([]);
      setTrendTableList([]);
      // setDateTimeDatas('month', '', '');
      setTrendLoading(false);
      setLoading(false);
      setTrendError(true);
      return {
        start_date: '',
        end_date: '',
      };
    }
  };

  const getEditionTrends = (lineDataRes: any) => {
    // 重组lineData , 将name 和 cover赋值给lineData
    const lineListMetric: any[] = [];
    lineDataRes?.forEach((metric: any) => {
      const newItem: any[] = [];
      metric?.detail_list?.forEach((item: any) => {
        const appIdItem = appIdListAll?.filter((obj: any) => obj?.id === item.app_id);
        if (appIdItem?.length > 0) {
          newItem.push(
            Object.assign(item, {
              name: appIdItem[0]?.name,
              cover: appIdItem[0]?.cover,
              platform: appIdItem[0]?.platform,
            }),
          );
        } else {
          newItem.push(item);
        }
      });
      lineListMetric.push({
        metric: metric.metric,
        detail_list: newItem,
      });
    });
    setEditionLineList(lineListMetric || []);
  };

  const getEdition = async (
    params: any,
    opts?: { bypassShortLinkSort?: boolean; signal?: AbortSignal },
  ) => {
    if (opts?.signal?.aborted) {
      return;
    }
    let newFetchParams = { ...fetchParams, ...params, data_source: currentDataSource };
    const orderName = opts?.bypassShortLinkSort
      ? newFetchParams?.order_field
      : shortLinkValidQuery?.[URL_2_SORT_NAME] || newFetchParams?.order_field;
    const orderField = newFetchParams?.metrics?.includes(orderName)
      ? orderName
      : newFetchParams?.metrics?.[0];
    const editionUrlCfg = {
      sortMetric: orderField,
      sortVal: opts?.bypassShortLinkSort
        ? 'desc'
        : shortLinkValidQuery?.[URL_2_ORDER] || 'desc',
      ratioType: opts?.bypassShortLinkSort
        ? 0
        : shortLinkValidQuery?.[URL_2_RATIO_TYPE] || 0,
    };
    newFetchParams = { ...newFetchParams, order_field: editionUrlCfg.sortMetric };
    setEditionLoading(true);
    setEditionMetricSegVal(editionUrlCfg.sortMetric);
    // eslint-disable-next-line no-prototype-builtins
    if (newFetchParams.hasOwnProperty('app_ids') && !newFetchParams.app_ids?.length) {
      setEditionLineList([]);
      setEditionTableList([]);
      setEditionError(true);
      setEditionLoading(false);
      return;
    }
    try {
      const editionRes = await statsRetentionMonthlyEditionShare(newFetchParams, {
        signal: opts?.signal,
      });
      if (opts?.signal?.aborted) {
        setEditionLoading(false);
        return;
      }
      if (editionRes?.code === 0 && !!editionRes?.data) {
        /** 将数据进行排序， 表格、柱状图排序展示， 可视化需要拿top5参数发给后端拿排序后的折线 */
        const dataList = editionRes?.data?.list || [];
        const sortData = sortTableByMetric({
          tableData: dataList,
          sortParams: editionUrlCfg,
          timeProperty: 'date',
          metricProperty: 'name',
          growthProperty: 'dod',
        });
        const totalList = editionRes?.data?.metrics_total || [];
        // 从basicinfo接口中提取头像和platform
        const tableList: any[] = [];
        setEditionFixedTableData([totalList]);
        sortData?.forEach((item: any) => {
          const appIdItem = appIdListAll.filter((obj: any) => obj?.id === item.app_id);
          tableList.push(Object.assign(item, ...appIdItem));
        });
        // const dataList = editionRes?.data?.list || [];
        const lineDataRes = editionRes?.data?.line_time || [];
        getEditionTrends(lineDataRes);
        setEditionTotalList(totalList || []);
        setEditionTableList(tableList || []);
      } else {
        setEditionLineList([]);
        setEditionTableList([]);
      }
      setEditionError(false);
    } catch (err) {
      if (!opts?.signal?.aborted) {
        setEditionLineList([]);
        setEditionTableList([]);
        setEditionError(true);
      }
    }
    setEditionLoading(false);
  };

  const getCountry = async (
    params: any,
    countryType: string,
    updateFilterValues = filterValue,
    fetchOpts?: { bypassShortLinkSort?: boolean; signal?: AbortSignal },
  ) => {
    if (fetchOpts?.signal?.aborted) {
      return;
    }
    const newFetchParams = {
      ...fetchParams,
      ...params,
      data_source: currentDataSource,
      region_type_share: countryType,
    };
    newFetchParams.app_ids = appIds;
    const orderName = countriesPageSortAttr.currentSortMetric || newFetchParams?.order_field;
    const orderField = newFetchParams?.metrics?.includes(orderName)
      ? orderName
      : newFetchParams?.metrics?.[0];
    const countriesUrlCfg = {
      sortMetric: orderField,
      sortVal: countriesPageSortAttr.currentSortValue || 'desc',
      ratioType: countriesPageSortAttr.currentRatioType || 0,
    };
    newFetchParams.order_field = countriesUrlCfg.sortMetric;
    setCountriesMetricSegVal(countriesUrlCfg.sortMetric);
    setFetchParams(newFetchParams);
    // setReqParamsDownLoad({ ...newFetchParams });
    setLoading(true);
    setMarketLoading(true);
    const marketType = getMaketsType(newFetchParams.regions, newFetchParams.regions);
    setMarketType(marketType);
    try {
      const isUpdateShortLinkNow = !!newFetchParams?.start_date && !!newFetchParams?.end_date;
      // 时间如果是空的，则需要更新时间筛选器
      const needUpdateTime = !newFetchParams?.start_date || !newFetchParams?.end_date;
      if (isUpdateShortLinkNow && hasUrlShortLink) {
        updateShortLinkFilterId({ [URL_FILTER_KEY]: updateFilterValues, [URL_APP_IDS]: appIds });
      }

      // eslint-disable-next-line no-prototype-builtins
      if (newFetchParams.hasOwnProperty('app_ids') && !newFetchParams.app_ids?.length) {
        setMarketLineList([]);
        setMarketTableList([]);
        setMarketError(true);
        setMarketLoading(false);
        setLoading(false);
        return;
      }
      const countryRes = await statsRetentionMonthlyMarketShare(newFetchParams, {
        signal: fetchOpts?.signal,
      });
      if (fetchOpts?.signal?.aborted) {
        setMarketLoading(false);
        setLoading(false);
        return;
      }
      let startDate = '';
      let endDate = '';
      if (countryRes?.code === 0 && !!countryRes?.data) {
        const totalList = countryRes?.data?.metrics_total || [];
        const tableList = countryRes?.data?.list || [];
        const sortData = sortTableByMetric({
          tableData: tableList,
          sortParams: countriesUrlCfg,
          timeProperty: 'date',
          metricProperty: 'name',
          growthProperty: 'dod',
        });
        // tableList.unshift(totalList ? totalList || {} : {})
        const topListTmp = getTopList(sortData);
        /** Monthly Retention筛选器选择Global时,表格名称展示Global,
          留存没有Global数据,所以数据还是Total的 */
        topListTmp.total = {
          ...totalList,
          // name: 'Total',
          // market: 'total',
        };
        topListTmp.global = {
          ...totalList,
          // name: 'Global',
          // market: 'global',
        };
        const firstFixedData = getFixedTableData(marketType, topListTmp);
        setTopList(topListTmp);
        setMarketFixedTableData(firstFixedData);

        // setReqParamsDownLoad({
        //   ...newFetchParams,
        //   start_date: marketRes?.req?.start_date,
        //   end_date: marketRes?.req?.end_date,
        // });
        startDate = countryRes?.req?.start_date;
        endDate = countryRes?.req?.end_date;
        if (startDate && endDate) {
          newFetchParams.start_date = startDate;
          newFetchParams.end_date = endDate;
        } else {
          const [defautStart, defautEnd] = getDefaultTime(newFetchParams.date_type, isTwoMonths);
          newFetchParams.start_date = defautStart;
          newFetchParams.end_date = defautEnd;
        }
        setFetchParams(newFetchParams);

        // 获取到时间后更新筛选器的值，并更新url短链接
        if (needUpdateTime && startDate && endDate) {
          const newFilterValue = updateTimeFilterValue({
            // hasUrlShortLinkVal,
            // haveFilterSaveBtn: true,
            // filterSaveName,
            filterValue: updateFilterValues,
            timeFilterValues: {
              type: newFetchParams.date_type,
              value: [newFetchParams.start_date, newFetchParams.end_date],
            },
          });
          setFilterVale(newFilterValue);
          // 如果是时间为空等时间返回更新 且有短链接功能，则更新短链接
          if (!isUpdateShortLinkNow && hasUrlShortLink) {
            updateShortLinkFilterId({ [URL_FILTER_KEY]: newFilterValue, [URL_APP_IDS]: appIds });
          }
        }
        setMarketLineList(countryRes?.data?.line_time || []);

        setMarketTotalList(totalList || []);
        setMarketTableList(topListTmp.list || []);
        // setMarketTableList(tableList || []);
      } else {
        setMarketLineList([]);
        setMarketTableList([]);
      }
      setMarketError(false);
    } catch (err) {
      if (!fetchOpts?.signal?.aborted) {
        console.error(err);
        setMarketLineList([]);
        setMarketTableList([]);
        setMarketError(true);
      }
    }
    setMarketLoading(false);
    setLoading(false);
  };

  const getPageData = (
    newFetchParams: any,
    updateFilterValues = filterValue,
    fetchOpts?: { bypassShortLinkSort?: boolean; signal?: AbortSignal },
  ) => {
    if (tabType === 'stats') {
      getStatsData(newFetchParams, updateFilterValues, fetchOpts);
    } else if (isCoutriesPage) {
      getCountry(newFetchParams, countryTypeRef.current, updateFilterValues, fetchOpts);
    } else {
      console.error(`tabType=${tabType} is not stats||countries!`);
    }
  };

  const changeMarketSegement = (value: string) => {
    // 修改参数
    countryTypeRef.current = value;
    getCountry(fetchParams, value);
  };

  const handleConfirm = (value: any, filter) => {
    const newFetchParams = {
      ...fetchParams,
      ...value,
      data_source: currentDataSource,
      order_field: value?.metrics?.[0],
    };
    // 获取页面接口
    getPageData(newFetchParams, filter);
    // 如果不是操作时间筛选器则请求最早时间接口，否则不请求接口
    if (
      value?.metrics !== fetchParams?.metrics ||
      value?.region_type !== fetchParams?.region_type ||
      value?.regions !== fetchParams?.regions
    ) {
      updateEarliestDateData({
        dataSources: [newFetchParams.data_source],
        metrics: newFetchParams.metrics,
        regionType: newFetchParams.region_type,
        regions: newFetchParams.regions,
        dateType: newFetchParams.date_type,
        platforms: newFetchParams?.platforms,
      });
    } else {
      /** 时间筛选器类型切换时， */
      const { earliestDay, earliestPeriod } = getEarliestDayAndEarliesPeriod(
        newFetchParams.date_type,
        newFetchParams.metrics,
      );
      setEarliestDay(earliestDay);
      setEarliestPeriod(earliestPeriod);
    }
  };

  const changeEditionSegement = (value: string) => {
    setEditionPageSortAttr({
      currentSortValue: 'desc',
      currentSortMetric: value,
      currentRatioType: 0,
    });
    setEditionMetricSegVal(value);
  };

  const changeMarketSegementRight = (value: string) => {
    setCountriesPageSortAttr({
      currentSortValue: 'desc',
      currentSortMetric: value,
      currentRatioType: 0,
    });
    setCountriesMetricSegVal(value);
  };

  return (
    <>
      <div className="dbi-statsfilter-warp">
        <div
          className={`statsfilter-warp-left${
            enableOpinionEvents ? ' dbi-mobile-stats-opinion-filter-wrap' : ''
          }`}
        >
          <Filter
            // timeFilterValues={{
            //   type: fetchParams.date_type,
            //   value: [fetchParams.start_date, fetchParams.end_date],
            // }}
            sinceReleaseTime={baseReleaseTimeValue}
            earliestDataTime={earliestPeriod}
            filterConfirm={handleConfirm}
            filterReset={() => {}}
            filterValue={filterValue}
            setFilterVale={setFilterVale}
            filterCfg={filterCfg}
            defaultValue={DEFAULT_FORM_VALUE}
          />
          {renderOpinionEventToolbar(opinionEventToolbar)}
        </div>
        <div className="dbi-statsfilter-warp-right">
          <ExportTable
            entityType="mobile"
            tableParams={{
              ...fetchParams,
              segment: pageId,
              source: fetchParams.data_source,
              unified_id: gameId,
              unified_ids: [gameId],
              entity_type: 'mobile',
            }}
            downloadTitleTips={DownloadTitleTips}
            businessType="mobile-stats-retentionmonthly"
            isShowMaxDownloadRowsTips={false}
            isDisableDownload={loading}
            downloadModalSize={820}
            isDisableDataAmount={true}
            isCalibrated={isCalibrated}
            newStyleFileName={`${basicInfo?.name}${
              tabType === 'stats' ? '_Stats' : isCoutriesPage ? '_Countries' : ''
            }`}
            isCoutriesPage={isCoutriesPage}
            downloadLogConfigKey={mobileStats?.[`${tabType}_${pageId}`]}
          />
        </div>
      </div>

      {isCoutriesPage ? (
        <CountriesCard
          loading={loading}
          tableData={marketTableList}
          lineData={marketLineList}
          // calOtherList={getCalOtherList(marketType, topList)}
          changeSegement={changeMarketSegement}
          changeSegementRight={changeMarketSegementRight}
          segmentOptions={fetchParams.metrics?.map((key) => ({ text: key, value: key }))}
          tableHeaderOptions={fetchParams.metrics?.map((key) => {
            const a = retentionAvgOptions.filter((t) => t.key === key)[0];
            return a;
          })}
          baseReleaseTime={baseReleaseTimeData}
          earliestPeriod={earliestPeriod}
          earliestDay={formattedEarliestDay}
          cardStatus={{
            isLoading: loading || marketLoading,
            isError: marketError,
            isNoData: !marketTableList?.length,
          }}
          fixedTableData={marketFixedTableData}
          entityType={entityType}
          gameName={basicInfo?.name}
          gameCover={basicInfo?.cover}
          dateType={fetchParams.date_type}
          startDate={fetchParams.start_date}
          endDate={fetchParams.end_date}
          earliestLoading={earliestLoading}
          setChartType={setMarketChartType}
          chartType={marketChartType}
          countriesType={countryTypeRef.current}
          pageSortAttr={countriesPageSortAttr}
          onTableSortChage={onTableSortChageCountrie}
          metricSegVal={countriesMetricSegVal}
          retentionMetricSource={currentDataSource}
          regionsCountries={regionsCountries || []}
        />
      ) : (
        <>
          <TrendsCard
            tableData={trendTableList}
            lineData={trendLineList}
            segmentOptions={fetchParams.metrics?.map((key) => ({ text: key, value: key }))}
            tableHeaderOptions={fetchParams.metrics?.map((key) => {
              const a = retentionOptions.filter((t) => t.key === key)[0];
              return a;
            })}
            cardStatus={{
              isLoading: loading || trendLoading,
              isError: trendError,
              isNoData: !trendTableList?.length,
            }}
            baseReleaseTime={baseReleaseTimeData}
            earliestPeriod={earliestPeriod}
            earliestDay={formattedEarliestDay}
            entityType={entityType}
            gameName={basicInfo?.name}
            gameCover={basicInfo?.cover}
            dateType={fetchParams.date_type}
            startDate={fetchParams.start_date}
            endDate={fetchParams.end_date}
            onTableSortChage={onTableSortChageTrend}
            pageSortAttr={trendPageSortAttr}
            retentionMetricSource={currentDataSource}
            lineSourceIcon={
              currentDataSource === 'sensortower' ? 'Sensor Tower' : 'appannie-white-bg'
            }
            trendLoading={trendLoading}
            enableOpinionEventAnnotation={enableOpinionEvents}
            controlledEventAnnotation={controlledEventAnnotation}
          />
          <ChannelsCard
            tableData={editionTableList}
            lineData={editionLineList}
            unPublishedAppIdList={unPublishedAppIdList}
            segmentOptions={fetchParams.metrics?.map((key) => ({ text: key, value: key }))}
            tableHeaderOptions={fetchParams.metrics?.map((key) => {
              const a = retentionAvgOptions.filter((t) => t.key === key)[0];
              return a;
            })}
            cardStatus={{
              isLoading: loading || editionLoading,
              isError: editionError,
              isNoData: !editionTableList?.length,
            }}
            fixedTableData={editonFixedTableData}
            entityType={entityType}
            gameName={basicInfo?.name}
            gameCover={basicInfo?.cover}
            dateType={fetchParams.date_type}
            startDate={fetchParams.start_date}
            endDate={fetchParams.end_date}
            earliestLoading={earliestLoading}
            pageSortAttr={editionPageSortAttr}
            onTableSortChage={onTableSortChageEdition}
            changeSegement={changeEditionSegement}
            metricSegVal={editionMetricSegVal}
            retentionMetricSource={currentDataSource}
          />
        </>
      )}
    </>
  );
}
